var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"smvp-preview-badge-container",attrs:{"aria-label":_vm.labels.ariaLabel}},[_c('badge',{staticClass:"smvp-preview-badge"},[_vm._v("Preview")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }